(function () {
    'use strict';

    angular.module("imApp").factory("dataMiningCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 821,
                    parameters: parms || {}
                });
            },
            createNewObj: function (edit) {
                return $ihttp.post({
                    method: 822,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
